module.exports = __webpack_public_path__ + "img/live3.32231f26.png";